import { FlaggedUser, TBlockedDetails, TRatingDetails } from "../../../store/dashboard/types";
import { IPaginatedData } from "../../../store/vacancy/types";
import PaginationControls from "../../Pagination/PaginationControls";
import CustomButton from "../../UI/Buttons/CustomButton";
import Location from "../../UI/Icons/Location";
import PersonID from "../../UI/Icons/PersonID";
import { format } from "date-fns";

const FlaggedCandidates = ({
  flagged_users,
  handleProfile,
  page,
  handlePageChange,
  setPerPage,
  setPage,
}: {
  flagged_users: IPaginatedData<FlaggedUser>;
  handleProfile: (candidate_uuid: string) => void;
  page: number;
  handlePageChange: (url: string | null) => void;
  setPerPage: (perPage: number) => void;
  setPage: (page: number) => void;
}) => {
  const { data, total, last_page, links } = flagged_users;

  const showBlockDetails = (blocked_by_other_users: TBlockedDetails[]) => {
    return (
      <>
        <div className="fs-13 fw-400 text-black">
          {`Blocked by ${blocked_by_other_users[0]?.blocked_by} on ${format(new Date(blocked_by_other_users[0]?.blocked_date), "d MMM yyyy")}`}
        </div>
        <div className="d-flex gap-5">
          <Location size={16} />
          <div className="fs-13 fw-400 text-black">
            {blocked_by_other_users.length > 1
              ? `${blocked_by_other_users[0]?.centre_name}, ${blocked_by_other_users[0].centre_adress}  + ${blocked_by_other_users.length-1} others`
              : `${blocked_by_other_users[0]?.centre_name}, ${blocked_by_other_users[0].centre_adress}`
            }
          </div>
        </div>
      </>
    );
  }

  const showRatingDetails = (candidate: FlaggedUser) => {
    const ratings = candidate.ratings
    
    return (
      <>
        { ratings.map((rating: TRatingDetails, index: number) => 
          <div key={index}>
            <div className="fs-13 fw-400 text-black">
              {`${rating?.rating} star rating by ${rating?.rated_by} on ${format(new Date(rating?.rating_date), "d MMM yyyy")}`}
            </div>
            <div className="d-flex gap-5">
              <Location size={16} />
              <div className="fs-13 fw-400 text-black">
                {rating.other_users_given_same_rating.length > 1
                  ? `${rating?.rating_centre}, ${rating.rating_centre_address}  + ${rating.other_users_given_same_rating.length-1} others`
                  : `${rating?.rating_centre}, ${rating.rating_centre_address}`
                }
              </div>
            </div>
            { (ratings.length > 1 || candidate.blocked_by_other_users.length > 0) && <div className="bg-off-white h-1px my-5px"></div> }
          </div>
        )}
      </>
    );
  }

  return (
    <div className="border border-grey-light radius-8px p-10px d-flex flex-column gap-10">
      {/* Header */}
      <div className="d-flex gap-3 align-items-center justify-content-between">
        <div className="d-flex gap-3 align-items-center">
          <PersonID />
          <div className="w-15px"></div>
          <div className="fs-45 fw-400 text-black">{total}</div>
          <div className="w-5px" />
          <div className="d-flex flex-column gap-3">
            <div className="fs-16 fw-700 text-black">Flagged Employees</div>
            <div className="fs-16 fw-400 text-grey-dark">
              Low rating in last 30 days, or blocked by centre
            </div>
          </div>
        </div>
      </div>

      {/* Flagged Candidate Cards */}
      {data.map((candidate) => (
        <div
          key={candidate.id}
          className="bg-white border border-off-white radius-8px py-8px px-10px d-flex gap-10"
        >
          <div className="pt-10px">
            <div className="min-w-40px w-40px h-40px radius-40px overflow-hidden">
              <img
                src={candidate?.photo || undefined}
                alt={candidate?.name}
                width={40}
                height={40}
                className="img-responsive rounded-circle object-fit-cover"
              />
            </div>
          </div>
          <div className="flex-grow-1 d-flex flex-column flex-lg-row gap-10 text-break">
            <div className="flex-grow-1 d-flex flex-column gap-3">
              <div className="fs-16 fw-700 text-black">{candidate?.name}</div>
              {candidate.ratings.length > 0 && showRatingDetails(candidate)}
              {candidate.blocked_by_other_users.length > 0 && showBlockDetails(candidate.blocked_by_other_users)}
            </div>
            <div className="pt-10px">
              <CustomButton
                variant="primary"
                type="button"
                className="btn-theme bg-off-white text-black max-h-30px min-w-126px"
                onClick={() => handleProfile(candidate.uuid)}
              >
                View Profile
              </CustomButton>
            </div>
          </div>
        </div>
      ))}
      {/* Render pagination controls if there are more than 10 users */}
      {total > 3 && (
        <PaginationControls
          currentPage={page} // Current page number
          totalPages={last_page} // Total number of pages
          paginationLinks={links} // List of pagination links
          itemsPerPageOptions={[3, 10, 20, 30, 50]} // override for this case
          onPageChange={handlePageChange} // Function to handle page change
          setPerPageList={setPerPage} // Function to set the number of items per page
          setCurrentPage={setPage} // Function to set the current page
        />
      )}
    </div>
  );
};

export default FlaggedCandidates;
